export default "__VITE_ASSET__pGI0vBDG__"